import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Income20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      d='M12.5 8.5C12.5 9.05228 12.0523 9.5 11.5 9.5C10.9477 9.5 10.5 9.05228 10.5 8.5C10.5 7.94771 10.9477 7.5 11.5 7.5C12.0523 7.5 12.5 7.94771 12.5 8.5Z'
      fill='currentColor'
    />
    <path
      d='M15.25 6.75H14V5.25H16.75V11.75H14V10.25H15.25V6.75Z'
      fill='currentColor'
    />
    <path
      d='M6.25 5.25L6.25 11.75H9V10.25H7.75V6.75H9L9 5.25L6.25 5.25Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.25 2.75H19.75V14.25H3.25V2.75ZM4.75 4.25V12.75H18.25V4.25H4.75Z'
      fill='currentColor'
    />
    <path d='M1.75 15.75V7.5H0.25V17.25H16V15.75H1.75Z' fill='currentColor' />
  </Svg>
);

Income20.displayName = 'Income20';
export default Income20;
